// Language-independent constants: section ids, contact info, image + logo paths.

export const NAV = [
  { id: "home", key: "home" },
  { id: "about", key: "about" },
  { id: "objectives", key: "objectives" },
  { id: "speakers", key: "speakers" },
  { id: "schedule", key: "schedule" },
  { id: "organizers", key: "organizers" },
  { id: "contact", key: "contact" },
];

export const FOOTER_NAV_IDS = ["home", "about", "speakers", "schedule", "contact"];

export const PHONES = ["+91-9836275042", "+91-7866038980"];
export const WEBSITE_LABEL = "www.iem.edu.in";
export const WEBSITE_URL = "https://www.iem.edu.in";
export const BROCHURE_URL = "https://vaani.iem.edu.in/brand/VAANI-Brochure.pdf";
export const REGISTER_URL = "https://atalacademy.aicte.gov.in/login";
export const FDP_ID = "FDP ID: 5817";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1644325349124-d1756b79dd42",
  about: "https://images.pexels.com/photos/9574516/pexels-photo-9574516.jpeg",
  vaani: "https://images.unsplash.com/photo-1581090464777-f3220bbe1b8b",
  campus: "/brand/campus.png",
};

export const LOGOS = {
  iem: "/brand/iem-logo.png",
  uem: "/brand/uem-logo.png",
  aicte: "/brand/aicte-logo.png",
};

export const scrollToId = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
